import React from "react";

export const Diagnosis01: React.FC = () => {
  return (
    <div id="diagnosis" className="diagnosis01-section">
      <div className="moreinfo-container">
        <h2 className="moreinfo-title moreinfo-title-blue moreinfo-title-left diagnosis01-title-mobile">Diagnóstico</h2>
        
        <div className="moreinfo-content">
          <div className="moreinfo-left">
            <div className="moreinfo-image-container">
              <img
                src="img/diagnosis.png"
                className="moreinfo-image"
                alt="Diagnóstico de endometriosis"
              />
            </div>
          </div>
          
          <div className="moreinfo-right">
            <h2 className="moreinfo-title moreinfo-title-blue moreinfo-title-left diagnosis01-title-desktop">Diagnóstico</h2>
            
            <p className="moreinfo-text">
              El diagnóstico de la endometriosis se basa en 3 pilares fundamentales:
            </p>
            
            <p className="moreinfo-text">
              <span className="diagnosis01-bullet">• <span className="diagnosis01-highlight-pink">EXAMEN FÍSICO E HISTORIA CLÍNICA:</span></span>
            </p>
            
            <p className="moreinfo-text">
              Lo más importante a la hora de buscar un diagnóstico de endometriosis es tratar con un médico especializado en el tema. 
              Ese médico va a tomarse un tiempo importante en repasar la <span className="moreinfo-highlight-blue">historia clínica</span> de 
              la persona y hacer preguntas que lo ayuden a orientar el diagnóstico. En esa misma consulta si es posible, también realizará 
              una <span className="moreinfo-highlight-blue">exploración física ginecológica</span> con el objetivo de buscar masas pélvicas, 
              nódulos y evaluar la movilidad del útero.
            </p>
            
            <p className="moreinfo-text diagnosis01-italic">
              Es importante que tengas presente que estas exploraciones sólo se pueden hacer con tu consentimiento, y que en CUALQUIER momento 
              de la misma, si sientes incomodidad o dolor, puedes pedirle al médico que la suspenda. <strong>Tú siempre eres quien tiene el 
              poder de decisión sobre todo lo que pase en tu cuerpo.</strong> No sientas miedo de pedir que detengan la exploración.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};